var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.998 9.56955C66.9682 8.53801 65.2974 8.53623 64.2676 9.56517L32.6182 41.1311L21.1991 28.7289C20.2124 27.6579 18.5442 27.5884 17.4714 28.575C16.3993 29.5617 16.3307 31.2307 17.3174 32.3027L30.5964 46.724C31.0827 47.2525 31.7633 47.5594 32.4809 47.5743C32.5002 47.5752 32.5188 47.5752 32.5372 47.5752C33.2346 47.5752 33.9055 47.2982 34.3997 46.8057L67.9928 13.3007C69.0251 12.2719 69.0269 10.6011 67.998 9.56955Z",
    fill: "#FF6F61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3617 32.3617C65.9046 32.3617 64.7236 33.5427 64.7236 35C64.7236 51.3903 51.3903 64.7236 35 64.7236C18.6107 64.7236 5.27639 51.3903 5.27639 35C5.27639 18.6107 18.6107 5.27639 35 5.27639C36.4571 5.27639 37.6383 4.09541 37.6383 2.63826C37.6383 1.18098 36.4571 0 35 0C15.7008 0 0 15.7008 0 35C0 54.2984 15.7008 70 35 70C54.2984 70 70 54.2984 70 35C70 33.5429 68.819 32.3617 67.3617 32.3617Z",
    fill: "#FF6F61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/completeIcon.9d799e9cf7b557d79df7a2547a174d62.svg";
export { ForwardRef as ReactComponent };